import * as React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import Downloads from "../../components/Downloads/Downloads";

const DownloadPage: React.FunctionComponent = () => {
    return (
        <Switch>
            <Route path="/download" component={Downloads} />
            <Redirect to="/download" />
        </Switch>
    );
};

export default DownloadPage;
